var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTimesRound = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.939 4.915c-1.815 1.811-2.939 4.314-2.939 7.081 0 5.523 4.477 10 10 10s10-4.477 10-10c0-2.757-1.115-5.253-2.92-7.062l0 0c-1.811-1.815-4.314-2.938-7.080-2.938-2.757 0-5.253 1.115-7.062 2.92l0-0zM15.539 9.515l-2.478 2.477 2.478 2.478c0.136 0.136 0.22 0.323 0.22 0.531 0 0.414-0.336 0.75-0.75 0.75-0.207 0-0.395-0.084-0.531-0.22l-2.477-2.478-2.478 2.478c-0.136 0.136-0.323 0.22-0.531 0.22-0.414 0-0.75-0.336-0.75-0.75 0-0.207 0.084-0.395 0.22-0.531l2.478-2.478-2.478-2.477c-0.136-0.136-0.22-0.323-0.22-0.531 0-0.414 0.336-0.75 0.75-0.75 0.207 0 0.395 0.084 0.531 0.22l2.478 2.478 2.477-2.478c0.136-0.136 0.323-0.22 0.531-0.22 0.414 0 0.75 0.336 0.75 0.75 0 0.207-0.084 0.395-0.22 0.531v0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimesRound, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/times-round.ad4e440f.svg";
export { ForwardRef as ReactComponent };